import store from '@/store'

const summarizedFlow = store.getters['auth/pharmaceuticalDomainConfig'].SUMMARIZEDFLOW

export const PSYCHIATRIC_ANSWER_VALUES = {
  NUNCA: 0,
  ALGUNS_DIAS: 1,
  MAIS_METADE_DIAS: 2,
  QUASE_TODOS_DIAS: 3,
}

export const PSYCHIATRIC_SCREENING_PERIODICITY = [
  { text: 'Nunca', value: 'NUNCA' },
  { text: 'Alguns dias', value: 'ALGUNS_DIAS' },
  { text: 'Mais da metade dos dias', value: 'MAIS_METADE_DIAS' },
  { text: 'Quase todos os dias', value: 'QUASE_TODOS_DIAS' },
]

export const PROFESSIONAL_OPTIONS = [
  {
    value: 'psiquiatra',
    text: 'Psiquiatra',
  },
  {
    value: 'psicologo',
    text: 'Psicólogo',
  },
  {
    value: 'outro',
    text: 'Outro',
  },
]

export const ANXIETY_DEPRESSION_OPTIONS = [
  {
    key: 'anxiety_depression',
    name: 'O paciente tem Ansiedade/Depressão?',
    options: [
      {
        value: 'SIM',
        text: 'Sim',
      },
      {
        value: 'NAO',
        text: 'Não',
      },
      {
        value: 'NAO_SEI',
        text: 'Não sabe dizer',
      },
    ],
    required: summarizedFlow,
    next_question: {
      key: 'toma_medicamento',
      name: 'Toma medicamento',
      options: [
        {
          value: true,
          text: 'Sim',
        },
        {
          value: false,
          text: 'Não',
        },
      ],
      required: summarizedFlow,
    },
  },
  {
    key: 'attendance',
    name: 'Faz acompanhamento?',
    options: [
      {
        value: true,
        text: 'Sim',
      },
      {
        value: false,
        text: 'Não',
      },
    ],
    next_question: {
      key: 'profissional',
      name: 'Profissional',
      options: [
        {
          value: 'psiquiatra',
          text: 'Psiquiatra',
        },
        {
          value: 'psicologo',
          text: 'Psicólogo',
        },
        {
          value: 'outro',
          text: 'Outro',
        },
      ],
    },
  },
  {
    key: 'support_group',
    name: 'Participa de algum grupo de apoio?',
    options: [
      {
        value: true,
        text: 'Sim',
      },
      {
        value: false,
        text: 'Não',
      },
    ],
  },
]
export const PROFILE_OPTIONS = [
  {
    section: {
      key: 'triagem_transtorno_ansiedade_generalizada',
      name: 'Triagem de Transtorno de Ansiedade Generalizada',
    },
    options: [
      {
        key: 'nervoso_ansioso_limite_duas_ultimas_semanas',
        name: 'Nas duas últimas semanas o quão frequentemente você se sentiu nervoso, ansioso ou no limite?',
      },
      {
        key: 'incapaz_controlar_preocupacoes_duas_ultimas_semanas',
        name: 'Nas duas últimas semanas o quão frequentemente você se sentiu incapaz de impedir ou controlar suas preocupações?',
      },
    ],
  },
  {
    section: { key: 'triagem_transtorno_depressivo', name: 'Triagem de Transtorno Depressivo' },
    options: [
      {
        key: 'pouco_interesse_prazer_duas_ultimas_semanas',
        name: 'Nas duas últimas semanas quantos dias você teve pouco interesse ou pouco prazer em fazer as coisas?',
      },
      {
        key: 'deprimido_duas_ultimas_semanas',
        name: 'Nas duas últimas semanas quantos dias você se sentiu para baixo, deprimido ou sem perspectiva?',
      },
    ],
  },
]

const DA_SUMMARIZED_KEYS = ['anxiety_depression']

export const ANXIETY_DEPRESSION_OPTIONS_SUMMARIZED = ANXIETY_DEPRESSION_OPTIONS.filter((option) =>
  DA_SUMMARIZED_KEYS.includes(option.key),
)
